// src/global/Globalapi.js
import axios from 'axios';

const axiosClient = axios.create({
  baseURL: 'http://localhost:5000/api',
});

export const getData = (url, params = {}) => axiosClient.get(url, { params });
export const postData = (url, data) => axiosClient.post(url, data);
export const putData = (url, data) => axiosClient.put(url, data);
export const deleteData = (url) => axiosClient.delete(url);

export default axiosClient;
